import React from "react";
import { Trans } from "react-i18next";
import { useDispatch } from "react-redux";
import moment from "moment";
import { setCurrentCycle } from "../../redux/cycle/action";
import { useAppTranslation } from "../../i18n/useAppTranslation";
import Network from "../../utils/Network";
import { roundFloat } from "../../utils/round-float";

type Props = {};

const Cycles = (props: Props) => {
  const { t } = useAppTranslation("learn");
  const axios = new Network();
  const [cycle, setCycle] = React.useState<any>();

  const dispatch = useDispatch();
  const handleGetCycle = async () => {
    const response = await axios.CallApi({
      url: "/cycles/current",
      method: "get",
    });
    setCycle(response.data);
    dispatch(setCurrentCycle(response.data));
  };

  React.useEffect(() => {
    handleGetCycle();
  }, []);

  const nextCycle = React.useMemo(() => {
    if (!cycle?.StartDate || !cycle?.MinDays) {
      return 0;
    }

    const startDate = new Date(cycle.StartDate);
    const currentTime = new Date(Date.now());
    const diff = moment(currentTime).diff(moment(startDate), "days");
    const now = (diff * 100) / cycle.MinDays;
    return Number.isFinite(now) ? now : 0;
  }, [cycle]);

  return (
    <div className="text-white pt-5">
      <div className="text-center fs-big">
        {t("learn:cycles.currentCycle", { number: cycle?.Number ?? "-" })}
      </div>
      <div className="form-processbar mt-3 align-items-center justify-content-center d-flex">
        <div className="me-3">
          {t("learn:cycles.nextCycle", { percent: roundFloat(nextCycle, 1) })}
        </div>
        <div
          style={{ maxWidth: "400px", flex: 1, minHeight: 25 }}
          className="progress"
        >
          <div
            style={{
              width: `${nextCycle}%`,
              minHeight: 16.5,
            }}
            className="progress-bar mx-2 progress-bar-striped blue"
          ></div>
        </div>
      </div>
      <div className="mt-4">
        <Trans
          i18nKey="learn:cycles.description"
          components={{
            priceLink: (
              <a
                href="https://whitepaper.chainoflegends.com/price-stability"
                target="_blank"
              />
            ),
          }}
        />
      </div>
      <div className="text-center mt-3">
        <img
          style={{ maxWidth: "800px" }}
          width="100%"
          src="/assets/images/daily-chart.jpg"
          alt={t("learn:cycles.chartAlt")}
        />
      </div>
    </div>
  );
};

export default Cycles;
